import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Offer} from '../../models/offer';

@Injectable({
  providedIn: 'root'
})
export class OfferService extends AbstractModelService<Offer> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/offer', Offer);
  }
}
